import api from './api';
import type {
  ManagedUser, EscalationContact, CreateUserPayload, UpdateUserPayload, UpdateProfilePayload, LoginResponseUser,
} from '../types/api';

export async function listUsers(): Promise<ManagedUser[]> {
  const r = await api.get<{ success: boolean; data: ManagedUser[] }>('/api/v1/auth/users');
  return r.data.data;
}

export async function createUser(payload: CreateUserPayload): Promise<ManagedUser> {
  const r = await api.post<{ success: boolean; data: ManagedUser }>('/api/v1/auth/users', payload);
  return r.data.data;
}

export async function updateUser(id: string, payload: UpdateUserPayload): Promise<ManagedUser> {
  const r = await api.patch<{ success: boolean; data: ManagedUser }>(`/api/v1/auth/users/${id}`, payload);
  return r.data.data;
}

export async function getEscalationContact(teamId: string): Promise<EscalationContact | null> {
  const r = await api.get<{ success: boolean; data: EscalationContact | null }>(`/api/v1/auth/escalation-contact/${teamId}`);
  return r.data.data;
}

export async function updateProfile(payload: UpdateProfilePayload): Promise<LoginResponseUser> {
  const r = await api.patch<{ success: boolean; data: LoginResponseUser }>('/api/v1/auth/me', payload);
  return r.data.data;
}
